import React from 'react';
import { Html, useProgress } from 'drei';
import './styles/Loader.css';

export default function Loader() {
    const { progress } = useProgress();

    return (
        <Html center>
            <div
                style={{
                    color: 'white',
                    boxShadow: '3px 3px 20px -1px rgba(0,0,0,0.43)',
                    borderRadius: 4,
                }}
                className="loaderContainer"
            >
                <div className="title">
                    Fields of Innovation
                    <div className="subTitle">Loading...</div>
                </div>

                    <div className="progressBackground">
                        <div className="progressFull">
                            <img alt="Loading" src="/assets/Loader/loader-full.png" width="205" style={{
                                clipPath: `polygon(0% ${100-progress}%, 100% ${100-progress}%, 100% 100%, 0% 100%)`,
                            }} />
                        </div>
                        <img alt="Loading background" src="/assets/Loader/loader-background.png" width="200" />

                        
                    </div>
            </div>
        </Html>
    );
}